/** The mail folder on screen (2026-10-09), for "search this folder": the
 *  Mail page says which folder it shows, the title bar's search box offers
 *  to search in it, and the search bar's Where chip lists it. `path` is the
 *  folder's path in the mailbox ("Inbox/Projects"), as `in:` matches it. */
import { useEffect, useState } from "react";

export type MailScope = { path: string; name: string };

let current: MailScope | null = null;
const listeners = new Set<(s: MailScope | null) => void>();

export function setMailScope(s: MailScope | null): void {
  if (s?.path === current?.path) return;
  current = s;
  for (const l of Array.from(listeners)) l(s);
}

export function getMailScope(): MailScope | null {
  return current;
}

export function useMailScope(): MailScope | null {
  const [s, setS] = useState<MailScope | null>(current);
  useEffect(() => {
    listeners.add(setS);
    setS(current);
    return () => {
      listeners.delete(setS);
    };
  }, []);
  return s;
}
